import { getJSONFromStorage } from './Helpers';
import { notifyHSMSDataMutation } from './HSMSDataSync';
import { API } from "aws-amplify";

export const submitDepartmentScreen = async (passed_data) => {
    const school_id = passed_data.school_id;
    const schedule_version_id = passed_data.schedule_version_id;
    const department_id = passed_data.department_id;
    const completed_subscreen = passed_data.completed_subscreen;

	const data = {school_id: school_id, completed_subscreen: completed_subscreen, department_id: department_id, schedule_version_id:schedule_version_id};
	
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/submit-department-screen';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);
    const result = response.data;
	
	return result;
}

export const updateUser = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/update-user';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);
    const response_data = response.data;
	
	return response_data;
}

export const saveSchoolInfo = async (data, _callback) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/save-school-info';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);
	
	const school_info = {...data, ...response.data};
	localStorage.setItem('schoolInfo', JSON.stringify(school_info));
	
	_callback();
}

export const saveSchoolSettings = async (data, _callback) => {
    //data : {school_id,  max_classes_in_a_row, max_teacher_classes_allowed, separate_ICR_codes}
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/save-school-settings';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    await API.post(apiName, url, myInit);

	notifyHSMSDataMutation({
		school_id: data.school_id,
		schedule_version_id: data.schedule_version_id,
		mutation_type: 'settings',
		data_type: 'school_settings',
	});
	
    const schedule_info = getJSONFromStorage('scheduleInfo', true);
	const new_schedule_info = {...schedule_info, ...data};

	localStorage.setItem('scheduleInfo', JSON.stringify(new_schedule_info));
	
	_callback();
}

export const saveScheduleType = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/save-schedule-type';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    await API.post(apiName, url, myInit);

	notifyHSMSDataMutation({
		school_id: data.school_id,
		schedule_version_id: data.schedule_version_id,
		mutation_type: 'settings',
		data_type: 'schedule_type',
	});
	
	const schedule_type = data.schedule_type;
	const scheduleInfo = getJSONFromStorage('scheduleInfo', true);
	
	// Set the schedule type in local storage
	scheduleInfo.schedule_type = schedule_type;
	localStorage.setItem("scheduleInfo", JSON.stringify(scheduleInfo));
	
	return;
} 

export const saveLunchStructure = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/save-lunch-structure';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    await API.post(apiName, url, myInit);

	notifyHSMSDataMutation({
		school_id: data.school_id,
		schedule_version_id: data.schedule_version_id,
		mutation_type: 'settings',
		data_type: 'lunch_structure',
	});
	
	return;
}

export const saveScheduleStructure = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/save-schedule-structure';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);
    const response_data = response.data;

	notifyHSMSDataMutation({
		school_id: data.school_id,
		schedule_version_id: data.schedule_version_id,
		mutation_type: 'settings',
		data_type: 'schedule_structure',
	});
	
	return response_data;
}

export const saveSIS = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/save-sis';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    await API.post(apiName, url, myInit);
	
	const sis = data.sis;
	const scheduleInfo = getJSONFromStorage('scheduleInfo', true);
	
	// Set the sis in local storage
	scheduleInfo.sis = sis;
	localStorage.setItem("scheduleInfo", JSON.stringify(scheduleInfo));
	
	return;
}

export const changeDataDepartment = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/change-data-department';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    const response = await API.post(apiName, url, myInit);
	const response_data = response.data;
	if(response_data && response_data.status === 'error')
	{
		throw response_data;
	}

	const slices_by_data_type = {
		course: ['courses', 'sections', 'departments'],
		teacher: ['teachers', 'sections', 'departments'],
		classroom: ['classrooms', 'sections', 'departments'],
		student: ['students', 'sections', 'departments'],
	};

	notifyHSMSDataMutation({
		school_id: data.school_id,
		schedule_version_id: data.schedule_version_id,
		slices: slices_by_data_type[data.data_type] || ['departments'],
		reason: 'change_data_department',
	});
	
	return response_data;
}

export const saveDataToDatabase = async (data) => {
    const database = ('database' in data && data.data_type === 'course') ? data.database : 'edario';
	const apiName = (database === 'edario') ? process.env.REACT_APP_ENDPOINT_NAME : process.env.REACT_APP_ELEM_ENDPOINT_NAME;
	const url = (database === 'edario') ? '/admin/save-data-to-database' : '/elementary/save-course';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
	let response_data;
    
	try {
		const response = await API.post(apiName, url, myInit);
		response_data = response.data;

		if(database === 'edario')
		{
			const refresh_targets = response_data?.refresh_targets || null;
			const hasTargetIDs = (target_group = {}) => (
				Array.isArray(target_group.ids) && target_group.ids.length > 0
			) || (
				Array.isArray(target_group.deleted_ids) && target_group.deleted_ids.length > 0
			) || (
				Array.isArray(target_group.course_ids) && target_group.course_ids.length > 0
			);
			let slices = null;

			if(refresh_targets?.type === 'student_save')
			{
				slices = ['students'];
				if(hasTargetIDs(refresh_targets.sections)) slices.push('sections', 'subsections');
			}
			else if(refresh_targets?.type === 'teacher_save')
			{
				slices = ['teachers'];
				if(hasTargetIDs(refresh_targets.sections)) slices.push('sections', 'subsections');
				if(hasTargetIDs(refresh_targets.courses)) slices.push('courses');
				if(hasTargetIDs(refresh_targets.students)) slices.push('students');
			}
			else if(refresh_targets?.type === 'classroom_save')
			{
				slices = ['classrooms'];
				if(hasTargetIDs(refresh_targets.sections)) slices.push('sections', 'subsections');
				if(hasTargetIDs(refresh_targets.courses)) slices.push('courses');
				if(hasTargetIDs(refresh_targets.teachers)) slices.push('teachers');
			}

			notifyHSMSDataMutation({
				school_id: data.school_id,
				schedule_version_id: data.schedule_version_id,
				data_version_id: data?.data_to_save?.data_version_id || null,
				mutation_type: 'save_data',
				data_type: data.data_type,
				slices,
				targets: refresh_targets,
				reason: `save_data:${data.data_type}`,
			});
		}
	} catch(e)
	{
		console.log(e.response);
	}
	
	return response_data;
}

export const saveDataLineEditor = async (data) => {
	const apiName = process.env.REACT_APP_ENDPOINT_NAME;
	const url = '/admin/save-data-line-editor';
    const myInit = {
        response: true,
        body: JSON.stringify(data),
    };

	let response_data;

	try {
		const response = await API.post(apiName, url, myInit);
		response_data = response.data;

		const slices_by_data_type = {
			course: ['courses', 'sections', 'students', 'departments'],
			teacher: ['teachers', 'sections', 'departments'],
			classroom: ['classrooms', 'sections', 'departments'],
			student: ['students', 'sections', 'departments'],
		};

		notifyHSMSDataMutation({
			school_id: data.school_id,
			schedule_version_id: data.schedule_version_id,
			mutation_type: 'save_data',
			data_type: data.data_type,
			slices: slices_by_data_type[data.data_type] || null,
			targets: response_data?.refresh_targets || null,
			reason: `save_data_line_editor:${data.data_type}`,
		});
	} catch(e)
	{
		console.log(e.response);
	}

	return response_data;
}

export const createInclusionLabels = async (data, _callback = () => {}) => {
    const apiName = process.env.REACT_APP_ENDPOINT_NAME;
    const url = '/admin/create-inclusion-labels';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
   
    try {
        await API.post(apiName, url, myInit);
        
        _callback();
    } catch(e)
    {
        console.log(e.response);
    }
}

export const saveElementarySchoolSettings = async (data, _callback) => {
    //data : {school_id,  start_time, end_time}
	const apiName = process.env.REACT_APP_ELEM_ENDPOINT_NAME;
	const url = '/elementary/save-schedule-info';
    const myInit = { // OPTIONAL
        response: true,
        body: JSON.stringify(data),
    };
    
    await API.post(apiName, url, myInit);
	
    const schedule_info = getJSONFromStorage('scheduleInfo', true);
	const new_schedule_info = {...schedule_info, ...data};

	localStorage.setItem('scheduleInfo', JSON.stringify(new_schedule_info));
	
	_callback();
}

export const saveElementaryHomeroomGrades = async (data) => {
	const apiName = process.env.REACT_APP_ELEM_ENDPOINT_NAME;
	const url = '/elementary/save-homeroom-grades';
	const myInit = {
		response: true,
		body: JSON.stringify(data),
	};

	const response = await API.post(apiName, url, myInit);
	const response_data = response.data;

	return response_data;
}
